import * as React from 'react';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureAppStore } from 'store/configureStore';
import { GlobalStyle, theme } from 'styles/global-styles';
import { RoutesV2 } from 'app/Routes';
import 'sanitize.css/sanitize.css';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import { LogRocketLogging } from 'log-rocket/LogRocket';
import { MaintenancePage } from '../../maintenance';
import { createInstance, OptimizelyProvider, setLogLevel, useDecision } from '@optimizely/react-sdk';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from 'oidc/userManager';
import { AxiosWrapper } from 'utils/AxiosWrapper';
import CssBaseline from '@mui/material/CssBaseline';
import { VisibilityProvider } from '@AMIEWEB/VisblityChange/VisiblityContext';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { ff_maintaince_key } from 'app/constants/FeatureFlags/Global/keys';
import { initNewRelic } from 'utils/newrelic/newrelic';

export const { store } = configureAppStore();
initNewRelic();
export const ApplicationRoot: React.FC = () => {
  const optimizely = createInstance({
    sdkKey: globalThis?.app?.env?.REACT_APP_OPTIMIZELY_SDK_KEY,
    datafileOptions: {
      autoUpdate: true,
      updateInterval: 300000,
    },
  });


  // License key for MUI X
  LicenseInfo.setLicenseKey(globalThis?.app?.env?.REACT_APP_MUI_X_PRO_KEY ?? '');

  setLogLevel('error');

  return (
    <>
      <MsalProvider instance={msalInstance}>
        <StyledEngineProvider injectFirst>
          <GlobalStyle />
          <CssBaseline>
            <ThemeProvider theme={theme}>
              <Provider store={store}>
                <React.StrictMode>
                  <div>
                    <AxiosWrapper>
                      <OptimizelyProvider optimizely={optimizely} userId={'all'}>
                        {/* <GlobalDisplay> */}
                        <VisibilityProvider>
                          <LogRocketLogging>
                            <MaintenceWrapper />
                          </LogRocketLogging>
                        </VisibilityProvider>
                        {/* </GlobalDisplay> */}
                      </OptimizelyProvider>
                    </AxiosWrapper>
                  </div>

                </React.StrictMode>
              </Provider>
            </ThemeProvider>
          </CssBaseline>
        </StyledEngineProvider>
      </MsalProvider>
    </>
  );
};

const MaintenceWrapper = (props) => {
  const [maintenanceEnabled] = useDecision(ff_maintaince_key, { autoUpdate: true });

  return (
    maintenanceEnabled.enabled ? (
      <MaintenancePage />
    ) : (
      <RouterProvider router={RoutesV2} />
    )
  )
}
